

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

@Component({
	components: {
	}
})
export default class AddSection extends Vue {
	public addingSection: boolean = false;
	public newSectionName: string = "";

	public createSection () {
		this.$emit("createSection", this.newSectionName)

		this.newSectionName = ""
		this.addingSection = false
	}
}
